/**
 * DashboardSubscribers entity class
 */

/**
 * DashboardSubscribersFactory
 * returns DashboardSubscribers entity class
 *
 * @class DashboardSubscribersFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.DashboardSubscribers} class
 *
 * @ngdoc factory
 * @name mwApp.factory:DashboardSubscribersFactory
 */
/* @ngInject */
export default function DashboardSubscribersFactory ($http, Entity) {
  /* === DashboardSubscribers class === */

  /**
   * DashboardSubscribers model
   *
   * @class DashboardSubscribers
   * @classdesc DashboardSubscribers model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.DashboardSubscribers} DashboardSubscribers entity
   */
  function DashboardSubscribers () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  DashboardSubscribers.prototype = Object.create(Entity.prototype)
  DashboardSubscribers.prototype.constructor = DashboardSubscribers

  /* === DashboardSubscribers instance methods & fields === */

  Object.assign(DashboardSubscribers.prototype, {

    /**
     * instance fields
     *
     * @memberof models.DashboardSubscribers#
     * @type {Object}
     */
    _fields: {
      totalSubscribersCount: 0,
      activeSubscribersCount: 0,
      expiredSubscribersCount: 0,
      onHoldSubscribersCount: 0,
      newSubscribersCount: 0,

      activeSubscribersGraph: Object
    },

    /**
     * Url template
     *
     * @memberof models.DashboardSubscribers#
     * @type {String}
     */
    _urlTemplate: 'api/dashboard/widgets/subscribers',

    /**
     * Public url template
     *
     * @memberof models.DashboardSubscribers#
     * @type {String}
     */
    _publicUrlTemplate: 'dashboard/widgets/subscribers',

    /**
     * Get service for subscribers
     *
     * @memberof models.DashboardPayments#
     * @private
     */
    _loadCount: function (params, callback) {
      return DashboardSubscribers.load({
        params,
        url: '\\count'
      }, { count: null })
        .then(({ count }) => callback.call(this, count))
    },

    /**
     * Get service for subscribers
     *
     * @memberof models.DashboardPayments#
     * @private
     */
    _loadNewCount: function (params, callback) {
      return DashboardSubscribers.load({
        params,
        url: '\\new\\count'
      }, { count: null })
        .then(({ count }) => callback.call(this, count))
    },

    /**
     * Get service for subscribers
     *
     * @memberof models.DashboardPayments#
     * @private
     */
    _loadGraph: function (params, callback) {
      return DashboardSubscribers.load({
        params,
        url: '\\graph'
      }, { graphView: null })
        .then(({ graphView }) =>
          typeof callback === 'function' ? callback.call(this, graphView) : graphView)
    },

    /**
     * Get service for subscribers
     *
     * @memberof models.DashboardPayments#
     * @private
     */
    _loadNewGraph: function (params, callback) {
      return DashboardSubscribers.load({
        params,
        url: '\\new\\graph'
      }, { graphView: null })
        .then(({ graphView }) =>
          typeof callback === 'function' ? callback.call(this, graphView) : graphView)
    },

    /**
     * Load subscriber's metrics service
     *
     * @returns {Promise}
     */
    loadMetrics: function () {
      return Promise.all([
        this._loadCount(null,
          function (payload) { this.totalSubscribersCount = payload || 0 }),
        this._loadCount({ status: 'ACTIVE' },
          function (payload) { this.activeSubscribersCount = payload || 0 }),
        this._loadCount({ status: 'EXPIRED' },
          function (payload) { this.expiredSubscribersCount = payload || 0 }),
        this._loadCount({ status: 'ON_HOLD' },
          function (payload) { this.onHoldSubscribersCount = payload || 0 }),
        this._loadNewCount({ days: 7 },
          function (payload) { this.newSubscribersCount = payload || 0 })
      ])
    }
  })

  /* === DashboardSubscribers static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(DashboardSubscribers, Entity)
  DashboardSubscribers._name = 'DashboardSubscribers'
  DashboardSubscribers.init()

  return DashboardSubscribers
}
